module.exports = __webpack_public_path__ + "static/media/end-flag.8e1f897d.png";